import React from 'react';
import type { InteractiveButton } from '../../types/message';

interface InteractiveButtonsProps {
  buttons: InteractiveButton[];
  onButtonClick?: (buttonId: string, buttonTitle: string) => void;
}

const QuickReplyIcon = () => (
  <svg className="w-4 h-4 text-[#00a884]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
  </svg>
);

export const InteractiveButtons: React.FC<InteractiveButtonsProps> = ({
  buttons,
  onButtonClick,
}) => {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {buttons.map((button) => (
        <button
          key={button.id}
          onClick={() => onButtonClick?.(button.id, button.title)}
          className="flex items-center gap-1.5 px-4 py-2 bg-warm-white border border-sketch rounded-lg hover:bg-cream active:bg-cream transition-colors shadow-sketch"
        >
          <QuickReplyIcon />
          <span className="text-sm font-medium text-[#00a884]">{button.title}</span>
        </button>
      ))}
    </div>
  );
};

export default InteractiveButtons;
